import { motion } from 'framer-motion';
import { ExternalLink, Code } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { projects } from '../data/projects';

const Projects = () => {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section
      id="projects"
      className="bg-gradient-to-b from-black to-gray-900 px-4 py-20 sm:px-6 lg:px-8"
    >
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-4xl font-bold text-transparent sm:text-5xl">
            PROJECTS
          </h2>
          <div className="mx-auto mb-4 h-1 w-24 bg-gradient-to-r from-blue-500 to-red-500"></div>
          <p className="mx-auto max-w-2xl text-lg text-gray-400">
            Edge Computing • Security • Software Engineering
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3"
        >
          {projects.map(project => (
            <motion.div
              key={project.id}
              variants={itemVariants}
              whileHover={{ scale: 1.05, y: -10 }}
              className="group cursor-pointer overflow-hidden rounded-xl border border-white/10 bg-white/5 backdrop-blur-md transition-all duration-300 hover:bg-white/10"
              onClick={() => navigate(`/projects/${project.id}`)}
            >
              <div className="flex h-48 items-center justify-center bg-gradient-to-br from-blue-500/20 to-red-500/20">
                <Code className="h-16 w-16 text-gray-400 transition-colors group-hover:text-blue-400" />
              </div>
              <div className="p-6">
                <h3 className="mb-2 text-xl font-bold text-white transition-colors group-hover:text-blue-400">
                  {project.title}
                </h3>
                <p className="mb-4 line-clamp-2 text-sm text-gray-400">{project.description}</p>
                <div className="mb-4 flex flex-wrap gap-2">
                  {project.technologies.slice(0, 3).map((tech, idx) => (
                    <span
                      key={idx}
                      className="rounded border border-blue-500/30 bg-blue-500/20 px-2 py-1 text-xs text-blue-300"
                    >
                      {tech}
                    </span>
                  ))}
                  {project.technologies.length > 3 && (
                    <span className="rounded border border-gray-500/30 bg-gray-500/20 px-2 py-1 text-xs text-gray-400">
                      +{project.technologies.length - 3}
                    </span>
                  )}
                </div>
                <button className="flex items-center gap-2 text-sm font-semibold text-blue-400 transition-colors hover:text-blue-300">
                  View Details
                  <ExternalLink className="h-4 w-4" />
                </button>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
